import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';

import { MultilanguageService } from './multilanguage.service';

@Injectable({ providedIn: 'root' })
export class PreferredMultilanguageGuard implements CanActivate {
  private readonly multilanguageService = inject(MultilanguageService);

  canActivate() {
    return this.validate();
  }

  private validate() {
    return this.multilanguageService.preferredLanguage$.pipe(
      filter((language) => !!language),
      map((language) => {
        const currentLanguage = this.multilanguageService.currentLanguage();
        if (currentLanguage !== language) {
          this.multilanguageService.selectLanguage(language);
        }
        return true;
      }),
      take(1),
    );
  }
}
